/**
 * Design tokens — ported from the mobile app (constants/theme.ts).
 * Industrial "job site" aesthetic: sharp corners, 2px borders, hi-vis orange.
 */

export type Palette = {
  bg: string;
  surface: string;
  ink: string;
  sub: string;
  border: string;
  hivis: string;
  chalk: string;
  green: string;
  tape: string;
  ghost: string;
  chalkTint: string;
  /** rgba fill behind a hi-vis / orange-selected option (mobile parity). */
  hivisTint: string;
  hatch: string;
};

export const LIGHT: Palette = {
  bg: '#F7F5F0',
  surface: '#FFFFFF',
  ink: '#14140F',
  sub: '#5C594F',
  border: '#D9D6CE',
  hivis: '#FF6A00',
  chalk: '#2456A6',
  green: '#1E9E4B',
  tape: '#FCFBF7',
  ghost: '#B9B5AA',
  chalkTint: 'rgba(36,86,166,0.08)',
  hivisTint: 'rgba(255,106,0,0.14)',
  hatch: 'rgba(20,20,15,0.05)',
};

export const NIGHT: Palette = {
  bg: '#17181A',
  surface: '#202225',
  ink: '#F2F1EC',
  sub: '#A8A69E',
  border: '#3A3C40',
  hivis: '#FF7E1F',
  chalk: '#4A7CD1',
  green: '#27B85C',
  tape: '#1D1F22',
  ghost: '#5E5C55',
  chalkTint: 'rgba(74,124,209,0.18)',
  hivisTint: 'rgba(255,126,31,0.22)',
  hatch: 'rgba(242,241,236,0.05)',
};

export const FIXED = {
  black: '#14140F',
  paper: '#F7F5F0',
};

export const FONT = {
  cond: '"Barlow Condensed", system-ui, sans-serif',
  body: '"Barlow", system-ui, sans-serif',
  mono: '"IBM Plex Mono", ui-monospace, monospace',
};

export const em = (emVal: number, fontSize: number) => `${emVal * fontSize}px`;

/** Hard offset shadow matching mobile shadowOffset 4,4 / shadowRadius 0 */
export const hardShadow = (color: string) => `4px 4px 0 ${color}`;
